import { servicesApi } from '@/services/api/deprecated';

interface Customer {
  id: string;
}

// TODO: Only partial interface is implemented, for limited usage
export interface People {
  customers: Customer[];
}

export const getPeople = async (environmentId: number | string | null) => {
  if (isNaN(parseInt(String(environmentId)))) {
    return null;
  }
  const { data } = await servicesApi.get<People>(`/environments/${environmentId}/customers`);

  return data;
};
